module.exports = __webpack_public_path__ + "static/casual-6e6bda6cbe2183cd5ed359f38306b971.png";